import { ClaimedOrderGridItem, ReturnedOrderGridItem } from 'skladon-types';
import { OrderType } from 'src/types/order';
import { OrderClaimsReturnsType, PendingOrderFilesType } from 'src/types/orderDetail';

export const formatData = (order: OrderType): OrderType => ({
    ...order
    // FILES: order.ORDER_FILES?.map((file) => file.FILE),
});

export const formatClaimsReturnData = (data: {
    claims: ClaimedOrderGridItem[];
    returns: ReturnedOrderGridItem[];
}): OrderClaimsReturnsType[] => {
    return [
        ...data.claims.map((item) => ({
            type: 'claim',
            ID: item.ID,
            ESHOP_ID: item.ESHOP_CLAIM_ID,
            STATUS: item.STATUS,
            TRACKING_NUMBER: item.TRACKING_NUMBER || undefined,
            SHIPPER: item.SHIPPER,
            typeKey: item.FCN,
            typeId: `claim_${item.ID}`,
            CREATED_AT: item.CREATED_AT
        })),
        ...data.returns.map((item) => ({
            type: 'return',
            ID: item.ID,
            ESHOP_ID: item.ESHOP_RETURN_ID,
            STATUS: item.STATUS,
            TRACKING_NUMBER: item.TRACKING_NUMBER || undefined,
            SHIPPER: item.ORDER_SHIPPER,
            typeKey: item.RMA,
            typeId: `return_${item.ID}`,
            CREATED_AT: item.CREATED_AT
        }))
    ];
};

/** Apply pending files onto a newly loaded order when IDs match. */
export const applyPendingOrderFiles = (
    order: OrderType,
    pending: PendingOrderFilesType | null
): { order: OrderType; pending: PendingOrderFilesType | null } => {
    if (pending && pending.orderId === order.ID && order.FILES === undefined) {
        return {
            order: { ...order, FILES: pending.files },
            pending: null,
        };
    }
    return { order, pending };
};

/** Keep non-empty files across clearOrderDetail so an in-flight fetch or create navigate does not lose them. */
export const stashOrderFilesOnClear = (
    data: OrderType | null,
    pending: PendingOrderFilesType | null
): PendingOrderFilesType | null => {
    if (data?.ID != null && data.FILES !== undefined && data.FILES.length > 0) {
        return { orderId: data.ID, files: data.FILES };
    }
    return pending;
};

/** Apply files fetch result to data or stash as pending when detail was cleared mid-flight. */
export const resolveFilesFetchSuccess = (params: {
    data: OrderType | null;
    pending: PendingOrderFilesType | null;
    orderId: number;
    files: NonNullable<OrderType['FILES']>;
}): { data: OrderType | null; pending: PendingOrderFilesType | null } => {
    const { data, pending, orderId, files } = params;
    if (data && data.ID === orderId) {
        return {
            data: { ...data, FILES: files },
            pending: pending?.orderId === orderId ? null : pending,
        };
    }
    return {
        data,
        pending: { orderId, files },
    };
};
